module.exports = __webpack_public_path__ + "static/media/play.4744c3f1.svg";